var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(-1496 -176)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1496 176)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1505 176)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1514 176)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1514 185)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1505 185)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1496 185)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1514 194)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1505 194)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(1496 194)",
    fill: "#2066a3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.26f0aece0461d11da20733a2a802cc30.svg";
export { ForwardRef as ReactComponent };